import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import http_request from './http_request'
import config from 'config'

function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function getUserByInstitution() {
	return http_agent.post(config.services + 'adminOnboarding/searchByInstitution.php')
		.send({})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function validateStep(path) {
	return http_request.post(config.services + 'adminOnboarding/validateStep.php')
		.send({
			path,
		})
}

function inviteUsers(userIds) {
	return http_agent.post(config.services + 'adminOnboarding/inviteUsers.php')
		.send({
			userIds,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function skipStep(step) {
	return http_request.post(config.services + 'user/loginNotification.php')
		.send({
			featureType: 6,
			action: step,
		})
}

function addUser(firstName, lastName, email) {
	return http_agent.post(config.services + 'adminOnboarding/new.php')
		.send({
			firstName,
			lastName,
			email,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function confirmSchool(schoolId, confirmSchool) {
	return http_request.post(config.services + 'adminOnboarding/validateSchoolConfirm.php')
		.send({
			schoolId,
			confirmSchool,
		})
}

function sendEmailToDM(firstName, lastName, email, phoneNumber, role) {
	return http_request.post(config.services + 'adminOnboarding/sendDMNotification.php')
		.send({
			name: firstName,
			lastName,
			email,
			phoneNumber,
			role,
		})
}

/* TODO: Update these functions about service loginNotification with the generic function loginNotification */
function noStoreDownloadsCompleted() {
	return http_request.post(config.services + 'user/loginNotification.php')
		.send({
			featureType: 'ADMIN_ONBOARDING_NO_DOWNLOADS_OVERLAY',
		})
}

function addTeachersCompleted() {
	return http_request.post(config.services + 'user/loginNotification.php')
		.send({
			featureType: 'FEATURE_ADMIN_ONBOARDING_ADD_TEACHERS_OVERLAY_ID',
		})
}

function noDMInformationCompleted() {
	return http_request.post(config.services + 'user/loginNotification.php')
		.send({
			featureType: 'FEATURE_ADMIN_ONBOARDING_NO_DM_OVERLAY_ID',
		})
}

function getTrialData(schoolUid) {
	return http_request.get(config.api + 'schools/free_trial/data')
		.send({
			schoolUid,
		})
}

function getPreData() {
	return http_request.get(config.api + 'schools/free_trial/data/pre').send({})
}

export default {
	getUserByInstitution,
	inviteUsers,
	validateStep,
	addUser,
	confirmSchool,
	sendEmailToDM,
	skipStep,
	noStoreDownloadsCompleted,
	addTeachersCompleted,
	noDMInformationCompleted,
	getTrialData,
	getPreData,
}
